import styled from 'styled-components';

const Nav = styled.div`
  padding: ${(props) => props.theme.spacing.baseSpace * 4}px 0;
`;

export default Nav;
